import React, { useEffect } from "react";
import styles from "./styles.module.scss";

import PageContainer from "../../Common/PageContainer/PageContainer";
import { Routes, Route, useNavigate } from "react-router-dom";

import Presentation from "./SubPages/Presentation";
import FormatCert from "./SubPages/FormatCert";
import OneFormation from "./SubPages/OneFormation";

function Formation(props) {
  const navig = useNavigate();
  const links = [
    {
      name: "Présentation",
      link: "/presentation",
    },
    {
      name: "FORMATIONS CERTIFIANTES",
      link: "/formations-certifiantes",
    },
    {
      name: "EXECUTIVE",
      link: "/executive",
    },
    {
      name: "CONCOURS",
      link: "/concours",
    },
  ];

  useEffect(() => {
    navig(`/formations/formations-certifiantes`);
  }, []);

  return (
    <div className={styles.main}>
      <PageContainer title="FORMATIONS" actual_link="/formations" links={links}>
        <Routes>
          {/* <Route path="/presentation" element={<Presentation />} /> */}
          <Route path="/formations-certifiantes" element={<FormatCert />} />
          <Route
            path="/formations-certifiantes/:id"
            element={<OneFormation />}
          />
          {/* <Route path="/executive" element={<h1>executive</h1>} /> */}
          {/* <Route path="/concours" element={<h1>concours</h1>} /> */}
        </Routes>
      </PageContainer>
    </div>
  );
}

export default Formation;
